import { AppThunk } from '@/app/store';
import { parseAxiosResponse } from '@/utils/parse_axios_response';
import {
  siteGetSuccess,
  siteGetsSucces,
  siteSetPagingOptions,
  sitesDelete,
  clearSites,
} from '@/slicers/sites';
import { ErrorPosition } from '@/slicers/response';
import { setResponse } from '@/slicers/response';
import { setFlashError, setFlashSuccess } from '@/slicers/flash';
import { MainApiCaller, TApiCaller } from '@/api-service';

@MainApiCaller('/normal_companies')
class CompaniesSitesRequest {
  caller!: TApiCaller;
  get(companyId: string, siteId: string) {
    return {
      request: (): AppThunk => async (dispatch) => {
        const response = await this.caller.GET(`/${companyId}/sites/${siteId}`);

        if (response.status === 200) {
          dispatch(siteGetSuccess(response.data));
          dispatch(setResponse(parseAxiosResponse(response)));
        } else {
          dispatch(setResponse(parseAxiosResponse(response)));
          dispatch(setFlashError('取得が失敗しました'));
        }
      },
    };
  }

  index(companyId: string) {
    return {
      request:
        (page?: number, keyword?: string): AppThunk =>
        async (dispatch) => {
          const query = {
            page: page || 1,
            search: keyword,
            paginate: page === -1 ? 0 : 1,
          };
          if (query.page === 1) {
            dispatch(clearSites());
          }

          const response = await this.caller.GET(`/${companyId}/sites`, query);

          if (response.status === 200) {
            dispatch(clearSites());
            if (Array.isArray(response.data)) {
              dispatch(
                siteSetPagingOptions({
                  total: response.data.length,
                  perPage: response.data.length,
                })
              );
              dispatch(siteGetsSucces(response.data));
            } else {
              const { data, total, per_page } = response.data;
              dispatch(
                siteSetPagingOptions({
                  total,
                  perPage: per_page,
                })
              );
              dispatch(siteGetsSucces(data));
            }

            dispatch(setResponse(parseAxiosResponse(response)));
          } else {
            dispatch(setResponse(parseAxiosResponse(response)));
            dispatch(setFlashError('取得が失敗しました。'));
          }
        },
    };
  }

  post(companyId: string) {
    return {
      request:
        (data: Record<string, any>): AppThunk =>
        async (dispatch) => {
          const response = await this.caller.POST(`/${companyId}/sites`, data);

          if (response.status === 201) {
            dispatch(siteGetSuccess(response.data));
            dispatch(setResponse(parseAxiosResponse(response)));
            dispatch(setFlashSuccess('追加しました'));
          } else {
            dispatch(setResponse(parseAxiosResponse(response)));
            dispatch(setFlashError('追加が失敗しました。'));
          }
        },
    };
  }

  put(companyId: string, siteId: string) {
    return {
      request:
        (data: Record<string, any>): AppThunk =>
        async (dispatch) => {
          const response = await this.caller.PUT(
            `/${companyId}/sites/${siteId}`,
            data
          );

          if (response.status === 200) {
            dispatch(siteGetSuccess(response.data));
            dispatch(setResponse(parseAxiosResponse(response)));
            dispatch(setFlashSuccess('更新しました'));
          } else {
            dispatch(
              setResponse({
                ...parseAxiosResponse(response),
                position: ErrorPosition.DRAWR,
              })
            );
            dispatch(setFlashError('更新が失敗しました。'));
          }
        },
    };
  }

  delete(companyId: string, siteId: string) {
    return {
      request: (): AppThunk => async (dispatch, getState) => {
        const response = await this.caller.DEL(`/${companyId}/sites/${siteId}`);

        dispatch(setResponse(parseAxiosResponse(response)));

        if (response.status === 200) {
          dispatch(setFlashSuccess('削除しました'));
          sitesDelete(dispatch, getState(), [Number(siteId)]);
          // dispatch(siteDeleteSuccess(Number(siteId)))
        } else {
          dispatch(setFlashError('削除が失敗しました。'));
        }
      },
    };
  }
}

const companiesSitesRequest = new CompaniesSitesRequest();

export default companiesSitesRequest;
